<template>
  <div class="DarkWhite">
           <v-card
      class="mb-5"
    >
        <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" sm="6" md="6" lg="3">
            <v-autocomplete
            v-model="FundCode"
            item-text="Description"
            item-value="FundCode"
            :items="funds"
            hide-details
            dense
            color="header"
            label="Filter by Funds"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="3">
          <v-autocomplete
            color="green"
            v-model="statusID"
            item-text="description"
            item-value="id"
            :items="statusList"
            dense
            hide-details
            label="Filter By Status"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="3">
          <v-menu
              dense
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="DateRange"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  dense
                  v-model="DateRange"
                  label="Date Range"
                  color="header"
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  clearable
                >
                </v-combobox>
              </template>
              <v-date-picker
                v-model="DateRange"
                no-title
                scrollable
                range
                color="header"
                :max="new Date().toISOString().substr(0, 10)"
              >
                <v-spacer></v-spacer>
                <v-btn text color="header" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  class="white--text"
                  color="header"
                  @click="$refs.menu1.save(DateRange)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="3">
            <v-autocomplete
            color="green"
            v-model="userID"
            item-text="name"
            item-value="UserID"
            :items="userList"
            dense
            hide-details
            label="Filter By User"
          >
          </v-autocomplete>
          </v-col>
        </v-row>
        </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="itemList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            style="max-width: 250px"
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search Item"
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <!-- <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            RSCODE: { title: 'RSCode' },
            IARCODE: { title: 'IARCode' },
            RISCODE: { title: 'RISCode' },
            ICSPARCODE: { title: 'ICS/PAR Code' },
            ReturnBy: { title: 'Returned By' },
            ReturnedDate: { title: 'Date Returned' },
            DateCreated: { title: 'Date Created' },
            }"
          csv-title="RS List">
            <v-btn
              outlined
              color="green darken-2"
              dark
              :loading="loadingCSV"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv> -->
          <v-btn @click="$refs.scanner.openScanner()" color="header" class="white--text">
            <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
            Scan Item
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.DateReturned`]="{ item }">
        {{ formatDate(item.DateReturned) }}
      </template>
      <template v-slot:[`item.Other_Actions`]="{ item }">
        <span class="text-no-wrap">
        <v-btn
          color="amber darken-2"
          class="mr-2"
          dark
          outlined
          elevation="2"
          x-small
          @click="dispense(item)"
          v-if="item.IsCancelled == 0 && item.NotedStatusID == 7"
        >
          Transfer
        </v-btn>
        <span class="grey--text" v-else-if="item.IsCancelled == 0 && item.NotedStatusID != 7" >For Approval</span>
        <span class="red--text" v-else >Cancelled</span>
        </span>
      </template>
      <template v-slot:[`item.IsPrinted`]="{ item }">
        <v-checkbox v-model="item.IsPrinted" color="header" @change="selectPrinted(item)"></v-checkbox>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
          <v-btn
            color="blue darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="viewRS(item)"
          >
            View
          </v-btn>
          <v-btn
            color="red darken-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="printRS(item)"
            v-if="item.IsCancelled == 0"
          >
            Print
          </v-btn>
        </span>
      </template>
    </v-data-table>
    <!-- <RSModal :rsData="rsData" />
    <ProcessModal :processData="processData" /> -->

    <Scanner
      ref="scanner"
      @scanned="onScanned"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import Scanner from "./Scanner.vue";
export default {
  components: {
    // RSModal: () => import("./ViewRS.vue"),
    // ProcessModal: () => import("./ProcessRS.vue"),
    Scanner
  },
  props: {
    fiscalYear: null
  },
  data: () => ({
    searchText: "",
    searchTimeout: null,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 10,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    headers: [
      {
          text: 'StockPropertyNo',
          align: 'start',
          sortable: false,
          value: 'StockPropertyNo',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'ItemName',
          align: 'start',
          sortable: false,
          value: 'ItemName',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Description',
          align: 'start',
          sortable: false,
          value: 'ItemDescription',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Location',
          align: 'start',
          sortable: false,
          value: 'Location',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Condition',
          align: 'start',
          sortable: false,
          value: 'Condition',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Scanned By',
          align: 'start',
          sortable: false,
          value: 'ScannedBy',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Scanned',
          align: 'start',
          sortable: false,
          value: 'DateScanned',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        { text: 'Actions', value: 'Actions', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      isLoading: false,
      itemList: [
  {
    StockPropertyNo: "SPN-2026-0001",
    ItemName: "Dell OptiPlex 7010 Desktop",
    ItemDescription: "Intel Core i5, 16GB RAM, 512GB SSD",
    Location: "ICT Office - Room 201",
    Condition: "Good",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:15:23"
  },
  {
    StockPropertyNo: "SPN-2026-0002",
    ItemName: "HP LaserJet Pro M404dn",
    ItemDescription: "Monochrome Network Laser Printer",
    Location: "Accounting Office",
    Condition: "Good",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:16:41"
  },
  {
    StockPropertyNo: "SPN-2026-0003",
    ItemName: "Lenovo ThinkPad E14",
    ItemDescription: "Intel Core i7, 16GB RAM, 1TB SSD",
    Location: "Registrar Office",
    Condition: "Needs Repair",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:18:12"
  },
  {
    StockPropertyNo: "SPN-2026-0004",
    ItemName: "Epson EcoTank L5290",
    ItemDescription: "All-in-One Ink Tank Printer",
    Location: "Library",
    Condition: "Good",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:19:55"
  },
  {
    StockPropertyNo: "SPN-2026-0005",
    ItemName: "Samsung 24-inch LED Monitor",
    ItemDescription: "24-inch Full HD IPS Display",
    Location: "MIS Office",
    Condition: "Good",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:21:08"
  },
  {
    StockPropertyNo: "SPN-2026-0006",
    ItemName: "Canon EOS 250D Camera",
    ItemDescription: "DSLR Camera with 18-55mm Lens",
    Location: "Media Center",
    Condition: "Excellent",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:22:44"
  },
  {
    StockPropertyNo: "SPN-2026-0007",
    ItemName: "Acer Veriton Desktop",
    ItemDescription: "Intel Core i3, 8GB RAM, 256GB SSD",
    Location: "Guidance Office",
    Condition: "Good",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:24:17"
  },
  {
    StockPropertyNo: "SPN-2026-0008",
    ItemName: "Brother DCP-T720DW",
    ItemDescription: "Wireless Ink Tank Printer",
    Location: "Supply Office",
    Condition: "For Repair",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:26:39"
  },
  {
    StockPropertyNo: "SPN-2026-0009",
    ItemName: "Cisco 24-Port Gigabit Switch",
    ItemDescription: "Managed Network Switch",
    Location: "Server Room",
    Condition: "Good",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:28:03"
  },
  {
    StockPropertyNo: "SPN-2026-0010",
    ItemName: "Dell Latitude 5440",
    ItemDescription: "Intel Core i5, 16GB RAM, 512GB SSD",
    Location: "President's Office",
    Condition: "Excellent",
    ScannedBy: "Ryan Rubiano",
    DateScanned: "2026-07-30 09:30:11"
  }
],
      // rsData: [],
      processData: [],
      statusList: [
        {id: 0, description: "All"},
        {id: 1, description: "Approved"},
        {id: 2, description: "For Approval"},
        {id: 3, description: "Cancelled"},
      ],
      statusID: 0,
      userList: [],
      funds: [],
      userID: 0,
      FundCode: 0,
      DateRange: null,
      menu1: false,
      DateType: false,
      DateEnd: null,
      dialogScan: false,
      html5QrCode: null,
      result: ""
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    userID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    statusID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    FundCode: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    DateRange: {
      handler(data) {
        if(data != null){
          this.DateType = true;
        }
        if(data == null || data.length != 1){
          this.initialize();
        }
      },
      deep: true,
    },
  },
  created() {
  },
  mounted() {
    this.eventHub.$on("closeViewRS", () => {
      this.initialize();
    });
    this.eventHub.$on("closeProcessRS", () => {
      this.initialize();
    });
    this.getUsers();
    this.getFundCodes();
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewRS");
    this.eventHub.$off("closeProcessRS");
  },
  methods: {
    viewRS(item) {
      this.rsData = item;
    },
    dispense(item) {
      this.processData = item;
    },
    printRS(item) {
      this.link = this.apiUrl + "/rs/report/" + item.RSID;
      window.open(this.link);
    },
    initialize() {
      // this.loading = true;
      // if(this.fiscalYear != null){
      // let data = new FormData();
      // if (this.options.page) {
      //   data.append("page", this.options.page);
      //   data.append("itemsPerPage", this.options.itemsPerPage);
      // } else {
      //   data.append("page", 1);
      //   data.append("itemsPerPage", 10);
      // }
      // data.append("tab", this.tab);
      // data.append("searchText", this.searchText);
      // data.append("FiscalYearID", this.fiscalYear);
      // data.append("StatusID", this.statusID);
      // data.append("UserID", this.userID);
      // data.append("FundCode", this.FundCode);
      // data.append("DateRange", this.DateRange && this.DateRange.length > 1 ? this.DateRange : '');
      // this.axiosCall("/getRSList", "POST", data).then((res) => {
        this.loading = false;
      //   this.rsList = res.data.data.result;
      //   this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      // });
      // }
    },
    getUsers() {
      this.axiosCall("/getAllPersonsAccountable", "GET").then((res) => {
        this.userList = [{UserID: 0, name: "All"},...res.data.data];
      });
    },
    getFundCodes() {
      this.axiosCall(
              '/get/getUniqueFundCodes',
              'GET'
          )
          .then((res) => {
              this.funds = this.prepend({FundCode: 0, Description: 'All'},res.data.data);
          })
		},
    selectPrinted(item) {
      let data = new FormData();
      data.append("id", item.RSID);
      data.append("table", 'rs');
      data.append("column", 'RSID');
      data.append("IsPrinted", item.IsPrinted ? 1 : 0);
      this.axiosCall("/setPrinted", "POST", data).then((res) => {
        if(res.data.status){
          let msg = item.IsPrinted ? 'printed.' : 'not printed.';
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = item.RSCODE + " was successfully set to " + msg;
          this.fadeAwayMessage.header = "System Message";
        }
        else{
          item.IsPrinted = !item.IsPrinted;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Something went wrong!";
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
  },
};
</script>